import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  close: {
    top: '16px',
    right: '12px'
  },

  rows: {
    display: 'flex',
    flexDirection: 'column'
  },

  row: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: '1rem'
    },

    '& > :first-child': {
      marginRight: '0.5rem'
    }
  },

  column: {
    flexDirection: 'column',
    alignItems: 'flex-start',

    '& > :first-child': {
      marginRight: '0',
      marginBottom: '0.5rem'
    }
  },

  label: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  scrollable: {
    flexDirection: 'column',
    width: '100%',
    maxHeight: '175px',
    overflow: 'auto'
  },

  input: {
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '100%',
    height: '36px',
    paddingLeft: '16px',
    paddingRight: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    background: '#F5F6F8',
    outline: 'none',

    '&::placeholder': {
      fontSize: theme.size.base,
      color: '#8F8F8F'
    }
  },

  menuRoot: {
    display: 'flex',
    alignItems: 'center',
    margin: '0',
    border: `solid 1px ${theme.border.outline}`,
    borderRadius: '4px',
    padding: '2px 0 2px 10px',
    cursor: 'pointer',
    fontSize: theme.size.base
  },

  description: {
    height: 'unset',
    maxHeight: '200px',
    padding: '16px',
    resize: 'none'
  },

  icon: {
    margin: '0px 7px',
    height: 'auto',
    width: '10px',
    opacity: '0.7',
    cursor: 'pointer'
  },

  button: {
    marginTop: '1rem',
    borderRadius: '8px',
    width: '100%',
    fontSize: theme.size.base
  }
}))

export default useStyles
